import { call, put, takeEvery, all } from 'redux-saga/effects'
import { login } from '../api'
import { postLearnerCourseReview } from '../helpers/api/api'

export function* signin(action) {
  try {
    const success = yield call(login, action.body)
    yield put({ type: 'SIGNIN_SUCCESS', success })
    yield window.localStorage.setItem('token', success.auth_token)
    yield put({ type: 'LOAD_ME' })
    yield action.onSuccess()
  } catch (error) {
    yield put({ type: 'SIGNIN_FAILURE', error })
    yield action.onFailure()
  }
}

export function* loadMe(action) {
  try {
    yield console.log('Fetch my profile...')
    yield put({ type: 'LOAD_ME_SUCCESS' })
  } catch (error) {
    yield put({ type: 'LOAD_ME_FAILURE', error })
  }
}

export function* addCourseReview(action) {
  try {
    //console.log('success', success)
  } catch (error) {
    //console.log('error', error)
  }
}

export function* addLearnerCourseReview(action) {
  try {
    const success = yield call(postLearnerCourseReview, action.payload)
    if (success.status) {
      yield put({ type: 'REVIEW_POST_SUCCESS' })
    } else {
      const message = success.error.non_field_errors[0]
      yield put({ type: 'REVIEW_POST_FAILED', message })
    }
  } catch (error) {
    const message = 'Failed to add review'
    yield put({ type: 'REVIEW_POST_FAILED', message })
  }
}

function* watchAddCourseReview() {
  yield takeEvery('POST_COURSE_REVIEW', addCourseReview)
}

function* watchAddLearnerCourseReview() {
  yield takeEvery('POST_LEARNER_COURSE_REVIEW', addLearnerCourseReview)
}

function* watchLoadMe() {
  yield takeEvery('LOAD_ME', loadMe)
}

function* watchSignin() {
  yield takeEvery('SIGNIN', signin)
}

export default function* rootSaga() {
  yield all([watchSignin(), watchLoadMe(), watchAddCourseReview(), watchAddLearnerCourseReview()])
}
